import i18n from "@src/common/lib/i18n";
import { Dic } from "$utils";

export const gasTableOption = function (isarea = false) {
  return {
    add: "新增",
    edit: "修改",
    view: "详情",
    stripe: true,
    page: true,
    maxHeight: "100%",
    align: "center",
    header: false,
    selection: true,
    emptyText: i18n.t("cameraList.title.noData"),
    delBtn: false,
    editBtn: false,
    labelWidth: "110px",
    menu: false,
    column: [
      // {
      //   prop: "check",
      //   search: true,
      //   searchSlot: true
      // },
      {
        label: "通信ID",
        prop: "parentThirdDeviceId",
        align: "center",
        search: true
      },
      {
        label: "名称",
        prop: "parentDeviceName",
        search: true
      },
      {
        label: "设备组",
        prop: "deviceWorkGroupName",
        hide: false,
        viewDisplay: true
      },
      {
        label: "区域",
        prop: "areaName",
        hide: true,
        viewDisplay: false
      },
      {
        label: "所属楼栋",
        prop: "buildName",
        hide: true,
        viewDisplay: false
      },
      {
        label: "是否室内",
        prop: "isIndoorName",
        hide: true,
        viewDisplay: false
      },
      {
        label: "制造厂",
        prop: "parentDeviceExtendMap",
        formatter: (row, value) => {
          return row.parentDeviceExtendMap
            ? row.parentDeviceExtendMap.manufacturer
            : "";
        },
        // viewDisplay:false,
        viewFormatter: (row, value) => {
          return value ? value.manufacturer : "";
        }
      },
      {
        label: "规格型号",
        prop: "parentDeviceVersion",
        type: "select"
      },
      {
        label: "介质属性",
        prop: "parentTypeMark",
        formatter: function (row, value) {
          return value ? Dic.findByValue("SENU110", value) : "";
        },

        viewFormatter: function (row, value) {
          return value ? Dic.findByValue("SENU110", value) : "";
        }
      },
      {
        label: "IP地址",
        prop: "parentIp",
        align: "center"
      },
      {
        label: "备注",
        prop: "parentDeviceDescription",
        align: "center",
        hide: true,
        span: 24
      },
      {
        label: "探测器数据地址",
        prop: "thirdDeviceId",
        columnWidth: 105
      },
      {
        label: "探测器名称",
        prop: "deviceName"
      },
      // {
      //   label: "低阈值",
      //   prop: "deviceExtendMap",
      //   formatter: (row, value) => {
      //     return row.deviceExtendMap
      //       ? row.deviceExtendMap.lowThreshold || ""
      //       : "";
      //   },
      //   viewFormatter: (row, value) => {
      //     return value ? value.lowThreshold || "" : "";
      //   }
      // },
      // {
      //   label: "高阈值",
      //   prop: "deviceExtendMap",
      //   formatter: (row, value) => {
      //     return row.deviceExtendMap
      //       ? row.deviceExtendMap.highThreshold || ""
      //       : "";
      //   },
      //   viewFormatter: (row, value) => {
      //     return value ? value.highThreshold || "" : "";
      //   }
      // },
      {
        label: "探测器介质属性",
        prop: "typeMark",
        columnWidth: 105,
        formatter: function (row, value) {
          return value ? Dic.findByValue("SENU110", value) : "";
        },
        viewFormatter: function (row, value) {
          return value ? Dic.findByValue("SENU110", value) : "";
        }
      },
      // {
      //   label: "测量介质",
      //   prop: "deviceExtendMap",
      //   formatter: (row, value) => {
      //     return row.deviceExtendMap
      //       ? row.deviceExtendMap.measureMedium || ""
      //       : "";
      //   },
      //   viewFormatter: (row, value) => {
      //     return value ? value.measureMedium || "" : "";
      //   }
      // }
    ]
  };
};
